const indexBannerSwiper = new Swiper("#index-banner-swiper", {
    slidesPerView: 1,
    autoplay: {
      delay: 3500,
    },
    loop: true,
    spaceBetween: 24,
});


$('#partner-slick').slick({
  infinite: true,
  slidesToShow: 5.2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4.1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4.9,
        slidesToScroll: 1
      }
    },
  ]
});

const menuItems = document.querySelectorAll('.navbar-nav > li > a.dropdown-toggle');

function dropdownToggle () {
  if (window.innerWidth > 992) {
    menuItems.forEach(item => {
      item.removeAttribute('data-bs-toggle')
    });
  } else {
    menuItems.forEach(item => {
      item.setAttribute('data-bs-toggle','dropdown')
    });
  }
};

dropdownToggle();
window.addEventListener('resize', dropdownToggle);

// tooltips init
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
